import axios from "axios";

export const getUserDetails = async (address) => {
    return new Promise(async (resolve, reject) => {
        await axios
            .get(
                `https://api-v2.zealy.io/public/communities/brufinance/users?ethAddress=${address}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "x-api-key": "cfab7cjVxuBySfZvXXa_OKYmsM8",
                    },
                },
            )
            .then((res) => {
                resolve(res.data);
            })
            .catch((e) => {
                console.log("%c Line:49 🥕 e", "color:#93c0a4", e);
                resolve(false);
            });
    });
};

export const getLaderBoardData = async () => {
    return new Promise(async (resolve, reject) => {
        await axios
            .get(
                `https://api-v2.zealy.io/public/communities/brufinance/leaderboard?page=1&limit=15`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "x-api-key": "cfab7cjVxuBySfZvXXa_OKYmsM8",
                    },
                },
            )
            .then((res) => {
                resolve(res.data);
            })
            .catch((e) => {
                console.log("%c Line:49 🥕 e", "color:#93c0a4", e);
                resolve(false);
            });
    });
};

export const getLaderBoardDataMonthAndWeek = async () => {
    return new Promise(async (resolve, reject) => {
        await axios
            .get(`https://prodbackend.bru.finance/quest/leaderboard`, {
                headers: {
                    "Content-Type": "application/json",
                    "x-api-key": "cfab7cjVxuBySfZvXXa_OKYmsM8",
                },
            })
            .then((res) => {
                resolve(res.data);
            })
            .catch((e) => {
                console.log("%c Line:49 🥕 e", "color:#93c0a4", e);
                resolve(false);
            });
    });
};
